"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ProviderSelect = _interopRequireDefault(require("../../components/ProviderSelection/ProviderSelect"));
var _browser = require("../../browser");
var ProviderSelection = function ProviderSelection(_ref) {
  var onClick = _ref.onClick,
    onBack = _ref.onBack,
    amount = _ref.amount;
  var _useIntl = (0, _reactIntl.useIntl)(),
    locale = _useIntl.locale;
  var providers = [_react["default"].createElement(_ProviderSelect["default"], {
    key: "flywire",
    provider: "flywire",
    onClick: onClick
  }), _react["default"].createElement(_ProviderSelect["default"], {
    key: "square",
    provider: "square",
    chargesInYen: true,
    onClick: onClick
  })];
  return _react["default"].createElement(_browser.Container, null, _react["default"].createElement(_browser.Title, {
    marginBottom: "0.3em"
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.selector.title"
  })), _react["default"].createElement(_browser.Subtitle, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.selector.selectedAmount.label"
  }), ":\xA0", _react["default"].createElement(_browser.Money, {
    value: amount
  })), _react["default"].createElement(_browser.Container, null, locale === 'en' ? providers : providers.reverse()), typeof onBack === 'function' && _react["default"].createElement(_browser.Button, {
    type: "button",
    color: "navigationBack",
    size: "large",
    onClick: function onClick() {
      return onBack();
    }
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.button.back"
  })));
};
var _default = exports["default"] = ProviderSelection;